import { render, staticRenderFns } from "./DataConversionPTC.vue?vue&type=template&id=4d19c5ab&scoped=true&"
import script from "./DataConversionPTC.vue?vue&type=script&lang=js&"
export * from "./DataConversionPTC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d19c5ab",
  null
  
)

/* custom blocks */
import block0 from "./DataConversionPTC.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports